/**
 * Protection des modals contre les invalidations Realtime.
 *
 * Quand une modal de saisie est ouverte, les invalidations React Query
 * déclenchées par Supabase Realtime sont mises en file d'attente.
 * Elles s'exécutent automatiquement à la fermeture de la dernière modal.
 *
 * Cela empêche le re-render des parents qui réinitialiserait les formulaires.
 *
 * Note : les invalidations des mutations (onSuccess) ne passent PAS par ici —
 * elles sont déclenchées volontairement par l'utilisateur.
 */

let _openCount = 0;
let _pendingInvalidations: (() => void)[] = [];

/** Signale l'ouverture d'une modal de saisie */
export function registerModalOpen() {
  _openCount++;
}

/** Signale la fermeture d'une modal. Flush la queue quand toutes sont fermées. */
export function registerModalClose() {
  _openCount = Math.max(0, _openCount - 1);

  if (_openCount === 0 && _pendingInvalidations.length > 0) {
    const fns = [..._pendingInvalidations];
    _pendingInvalidations = [];
    fns.forEach(fn => fn());
  }
}

/**
 * Exécute une invalidation immédiatement si aucune modal n'est ouverte,
 * sinon la met en file d'attente pour exécution au close.
 */
export function queueOrExecuteInvalidation(fn: () => void) {
  if (_openCount > 0) {
    _pendingInvalidations.push(fn);
  } else {
    fn();
  }
}

/** Vérifie si au moins une modal de saisie est ouverte */
export function isAnyModalOpen() {
  return _openCount > 0;
}
